import { Download } from "lucide-react";
import { Document, documentDownloadLink } from "~/document";
import { Button } from "~/components/ui/button";

const DocumentDownloadButton = (props: { doc: Document; className?: string }) => {
  return (
    <Button asChild variant="secondary" size="sm" className={props.className}>
      <a href={documentDownloadLink(props.doc)} target="_blank" rel="noopener noreferrer">
        <Download />
        Download file
      </a>
    </Button>
  );
};

export default DocumentDownloadButton;
